import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip } from 'react-tooltip';

export const GlobalTooltipTemplate = (): JSX.Element => {
    const tooltip = (
        <div>
            <Tooltip className="tooltip" id="favourite-tooltip" />
        </div>
    );

    if (typeof window === 'undefined') {
        return null;
    }

    const container = document.getElementById('tooltips-container');

    return container ? ReactDOM.createPortal(tooltip, container) : null;
};
